export const addStock = async (stockData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...stockData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = stockData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Stock Response:', response);
    return jsonResponse;
};
export const updateStock = async (stockId, stockData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: stockId, ...stockData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = stockData;
        data.id = stockId;
        jsonResponse.data = data;
    }
    console.log('Update Stock Response:', response);
    return jsonResponse;
};
export const deleteStock = async (stockId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: stockId})
    });
    return await response.json();
};


/**
 * Add bulk stock items to the inventory
 * 
 * @param {Object} data - The bulk stock data
 * @returns {Promise<Object>} - API response
 */
export const addBulkStock = async (data) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'addBulkStock',
                apiKey: process.env.REACT_APP_API_KEY,
                origin: window.location.origin,
                ...data
            })
        });

        const result = await response.json();
        
        if (!response.ok) {
            throw new Error(result?.error || `HTTP error! status: ${response.status}`);
        }

        return result;
    } catch (error) {
        console.error('Error in addBulkStock service:', error);
        return {
            success: false,
            error: error.message,
            message: error.message || 'Failed to add bulk stock items'
        };
    }
};